import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { XIcon, CartIcon } from "../../assets/icons/index";
import Backdrop from "../common/Backdrop";
import useBodyScrollLock from "../../hooks/useBodyScrollLock";
import CartItemCard from "../cart/CartItemCard";
import { useState } from "react";
import {
    closeCart,
    increaseQty,
    decreaseQty,
    removeFromCart,
} from "../../features/cart/cartSlice";
import { fetchSyncCart } from "../../features/cart/cartSlice";
import DeleteConfirmModal from "../ui/DeleteConfirmModal";

function CartDrawer() {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const { isOpen, product } = useSelector((state) => state.cart);

    useBodyScrollLock(isOpen);

    const syncToServer = (updatedProducts) => {
        if (!user) return;
        dispatch(fetchSyncCart({
            userId: user.userId,
            items: updatedProducts.map(item => ({
                product_id: item.product_id,
                product_name: item.name,
                size_value: item.size,
                qty: Number(item.qty) || 1
            }))
        }));
    };

    const handleIncrease = (item) => {
        dispatch(increaseQty(item));
        const updated = product.map(p =>
            p.product_id === item.product_id &&
                p.size_id === item.size_id &&
                p.flavour === item.flavour
                ? { ...p, qty: (Number(p.qty) || 1) + 1 }
                : p
        );
        syncToServer(updated);
    };

    const handleDecrease = (item) => {
        dispatch(decreaseQty(item));
        const updated = product
            .map(p =>
                p.product_id === item.product_id &&
                    p.size_id === item.size_id &&
                    p.flavour === item.flavour
                    ? { ...p, qty: (Number(p.qty) || 1) - 1 }
                    : p
            )
            .filter(p => p.qty > 1);
        syncToServer(updated);
    };

    const handleRemove = (item) => {
        dispatch(removeFromCart(item));
        const updated = product.filter(p => !(
            p.product_id === item.product_id &&
            p.size_id === item.size_id &&
            p.flavour === item.flavour
        ));
        syncToServer(updated);
    };
    const [deleteItem, setDeleteItem] = useState(null);

    const handleDeleteClick = (item) => {
        setDeleteItem(item); // open modal
    };

    const confirmRemove = () => {
        if (!deleteItem) return;

        handleRemove(deleteItem); 
        setDeleteItem(null);    
    };
    return (
        <>
            <Backdrop
                isOpen={isOpen}
                onClose={() => dispatch(closeCart())}
            />

            <div className={`fixed top-0 right-0 h-full md:w-[420px] w-[90%] px-3 bg-white z-3 shadow-2xl transition-all duration-500 rounded-l-4xl
                ${isOpen ? "translate-x-0" : "translate-x-full"}`}
            >
                <div className="flex items-center justify-between p-4">
                    <h2 className="text-[14px] font-semibold">YOUR CART</h2>
                    <button onClick={() => dispatch(closeCart())}>
                        <XIcon className="w-7 h-7 text-gray-700 cursor-pointer hover:bg-gray-100 hover:rounded-lg p-[3px] transition" />
                    </button>
                </div>

                {product.length > 0 ? (
                    <div className="rounded-lg bg-gray-100">
                        {product.map((item, index) => (
                            <CartItemCard
                                key={index}
                                item={item}
                                onIncrease={() => handleIncrease(item)}
                                onDecrease={() => handleDecrease(item)}
                                onDelete={() => confirmRemove(item)}
                                onDelete={() => handleDeleteClick(item)}
                            />
                        ))}
                    </div>
                ) : (
                    <div className="flex flex-col items-center justify-center h-[80%] text-center px-6">
                        <CartIcon className="w-10 h-10 mb-4" />
                        <p className="text-gray-500 text-[16px]">Your cart is empty</p>
                    </div>
                )}
                {deleteItem && (
                    <DeleteConfirmModal
                        item={deleteItem}
                        onConfirm={confirmRemove}
                        onCancel={() => setDeleteItem(null)}
                    />
                )}
            </div>

        </>
    );
}

export default CartDrawer;